import {
  IconButton,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Tooltip,
  Typography,
} from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import DraftsIcon from '@material-ui/icons/Drafts';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import MarkunreadIcon from '@material-ui/icons/Markunread';
import moment from 'moment';
import React from 'react';
import { NoticeDTO } from '../../../../../models/dto/NotificationDTO';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    card: {
      height: '100%',
    },
    cardHeaderContainer: {
      padding: theme.spacing(2),
      paddingBottom: 0,
    },
    notificationContentContainer: {
      height: '100%',
      paddingTop: 0,
      overflowY: 'auto',
    },
    notificationTitleText: {
      fontWeight: 'bold',
      display: 'inline',
    },
    notificationText: {
      display: 'inline',
      marginLeft: theme.spacing(1),
    },
    newNotificationIcon: {
      color: theme.palette.info.main,
      fontSize: 12,
      marginTop: theme.spacing(1),
      marginRight: theme.spacing(1),
    },
  }),
);

interface NotificationItemProps {
  notification: NoticeDTO;
  changeNotificationVisualized: (notification: NoticeDTO) => void;
}

const NotificationItem: React.FC<NotificationItemProps> = ({
  notification,
  changeNotificationVisualized,
}) => {
  const classes = useStyles();

  return (
    <ListItem divider disableGutters dense alignItems="flex-start">
      <FiberManualRecordIcon
        style={{
          visibility: !notification.visualizedAt ? 'visible' : 'hidden',
        }}
        className={classes.newNotificationIcon}
      />
      <ListItemText
        primary={
          <>
            <Typography
              variant="body1"
              className={classes.notificationTitleText}
              color={
                !notification.visualizedAt ? 'textPrimary' : 'textSecondary'
              }
            >
              {notification.title}
              <Typography variant="body1" className={classes.notificationText}>
                {notification.message}
              </Typography>
            </Typography>
          </>
        }
        secondary={
          <Typography
            variant="body2"
            className={classes.notificationTitleText}
            color={!notification.visualizedAt ? 'textPrimary' : 'textSecondary'}
          >
            {moment(notification.createdAt, 'DD/MM/YYYY HH:mm:ss').fromNow()}
          </Typography>
        }
      />
      <ListItemSecondaryAction>
        <Tooltip
          title={
            notification.visualizedAt
              ? 'Marcar como não visualizada'
              : 'Marcar como visualizada'
          }
          arrow
          placement="left"
        >
          <IconButton
            edge="end"
            onClick={() => changeNotificationVisualized(notification)}
          >
            {notification.visualizedAt ? <MarkunreadIcon /> : <DraftsIcon />}
          </IconButton>
        </Tooltip>
      </ListItemSecondaryAction>
    </ListItem>
  );
};

export default NotificationItem;
